export default {
  sizes: [8, 16, 32, 64, 128, 256, 512, 768, 1024, 1536]
};
